<template>
  <div dark>
    <header class="container">
      <h2>Shopping Cart</h2>
    </header>
    <v-layout wrap>
      <v-flex xs12 lg6 style="padding-right: 10px;">
        <v-select
      label="Select Customer"
      v-model="customer"
      :items="customers"
      item-text="name"
      item-value="_id"
    >
    <template slot="selection" slot-scope="{ item, index }">
    <span v-if="!index">{{  item.name.substring(0,20)}}</span>
    </template></v-select>
    </v-flex>
    <v-flex xs12 lg6 style="padding-right: 10px;">
        <v-select
      label="Select License"
      v-model="licensee"
      :items="licenses"
      item-text="name"
      item-value="_id"
    >
    <template slot="selection" slot-scope="{ item, index }">
    <span v-if="!index">{{  item.name.substring(0,20)}}</span>
    </template></v-select>
    </v-flex>
    <v-flex xs12 lg6 style="padding-right: 10px;">
        <v-select
      label="Select Transporter"
      v-model="transporter"
      :items="transporters"
      item-text="name"
      item-value="_id"
    >
    <template slot="selection" slot-scope="{ item, index }">
    <span v-if="!index">{{  item.name.substring(0,20)}}</span>
    </template></v-select>
    </v-flex>
    </v-layout>
    <section class="container">
      <div v-if="items.length > 0">
        <table style="width: 100%; ">
          <tr style="border-bottom: 1px solid;font-size: 1.2rem; color: #4698ec">
            <th >Item</th>
            <th >Item Price</th>
            <th >Quantity</th>
            <th >Subtotal</th>
            <th >Remove</th>
          </tr>
          <tr v-for="(product, index) in items" :key="index"
          >
            <td style="padding: 5px;">
              <div style="color: #16cc9b; font-weight: bold">
                {{product.name}}
              </div>
              </td>
            <td style="padding-left: 10px;">
              <div class="quantity">
                <input
                  type="number"
                  class="quantity"
                  step="1"
                  :value="product.price"
                  @input="updatePrice(index, $event)"
                  @blur="checkQuantity(index, $event)"
                />
              </div>
            </td>
            <td>
              <div class="quantity">
                <input
                  type="number"
                  class="quantity"
                  step="1"
                  :value="product.quantity"
                  @input="updateQuantity(index, $event)"
                  @blur="checkQuantity(index, $event)"
                />
              </div>
            </td>
            <td>
              {{product.subTotal}}
            </td>
            <td>
              <div class="remove">
                <svg
                  @click="removeItem(index)"
                  version="1.1"
                  class="close"
                  xmlns="//www.w3.org/2000/svg"
                  xmlns:xlink="//www.w3.org/1999/xlink"
                  x="0px"
                  y="0px"
                  viewBox="0 0 60 60"
                  enable-background="new 0 0 60 60"
                  xml:space="preserve"
                >
                  <polygon
                    points="38.936,23.561 36.814,21.439 30.562,27.691 24.311,21.439 22.189,23.561 28.441,29.812 22.189,36.064 24.311,38.186 30.562,31.934 36.814,38.186 38.936,36.064 32.684,29.812"
                  />
                </svg>
              </div>
            </td>
          </tr>
        </table>
      </div>
      <div v-else class="empty-product">
        <h3>There are no items in your cart.</h3>
      </div>
    </section>
    
    <section class="container" v-if="items.length > 0">
      <div class="promotion">
        
        <!-- <label for="promo-code">Have A Promo Code?</label>
        <input type="text" id="promo-code" v-model="promoCode" /> <button type="button" @click="checkPromoCode"></button>-->
      </div>

      <div class="summary">
        <ul>
          <li>
            Total (before tax)
            <span>{{ subTotal | currencyFormatted }}</span>
          </li>
          <!-- <li v-if="discount > 0">
            Discount
            <span>{{ discountPrice | currencyFormatted }}</span>
          </li> -->
          <!-- <li>Tax will be calculated when generating invoice</li> -->
        </ul>
      </div>
 
    </section>

     <v-textarea outline style="padding-right: 12px" 
        label="Notes"
        v-model="notes"
      >
      </v-textarea>
    <section class="container" v-if="items.length > 0">
      
 
      <div class="checkout">
        <v-btn class="sbutton" :disabled="!enablecheckout" @click="send()" >Create Invoice</v-btn>
      </div>
    </section>
    <!-- End Summary -->
  </div>
</template>

<script>
import { sync } from "vuex-pathify"
import axiosInstances from "@/../../coreui/server/axiosInstances"
export default {
  props: ["cartclosed", "items"],
  data: () => ({
    tax: 5,
    customer: null,
    customers: [],
    licenses: [],
    licensee: null,
    transporters: [],
    transporter: null,
    promoCode: "",
    discount: 0,
    notes: null
  }),
  computed: {
    dark: sync("misc/dark"),
    enablecheckout () {
      return this.customer != null && this.licensee != null && this.transporter != null && this.items.length > 0
    },
    itemCount: function () {
      var count = 0

      for (var i = 0; i < this.items.length; i++) {
        count += parseInt(this.items[i].quantity) || 0
      }

      return count;
    },
    subTotal: function () {
      var subTotal = 0;
      for (var i = 0; i < this.items.length; i++) {
        subTotal += this.items[i].quantity * this.items[i].price
      }
      return subTotal.toFixed(2)
    },
    discountPrice: function () {
      return (this.subTotal * this.discount) / 100
    },
    totalPrice: function () {
      return this.subTotal - this.discountPrice + this.tax;
    },
  },
  filters: {
    currencyFormatted: function (value) {
      return Number(value).toLocaleString("en-US", {
        style: "currency",
        currency: "USD",
      });
    },
  },
  methods: {
    backbutton() {
      // console.log("emiting cartclosed");
      this.$emit("update:cartclosed", true);
    },
    updateQuantity: function (index, event) {
      var product = this.items[index];
      var value = event.target.value;
      var valueFloat = parseFloat(value);

      // Minimum quantity is 1, maximum quantity is 100, can left blank to input easily
      if (value === "") {
        product.quantity = value;
      } else if (valueFloat > 0 && valueFloat < 10000) {
        product.quantity = valueFloat;
      }
      product.subTotal = (product.quantity * product.price).toFixed(2)
      this.$set(this.items, index, product);
    },
    updatePrice: function (index, event) {
      var product = this.items[index];
      var value = event.target.value;
      var valueFloat = parseFloat(value);
      // Minimum quantity is 1, maximum quantity is 100, can left blank to input easily
      if (value === "") {
        product.price = value;
      } else if (valueFloat > 0 && valueFloat < 10000) {
        product.price = valueFloat;
      }
      product.subTotal = (product.quantity * product.price).toFixed(2)
      this.$set(this.items, index, product);
    },
    checkQuantity: function (index, event) {
      // Update quantity to 1 if it is empty
      if (event.target.value === "") {
        var product = this.items[index];
        product.quantity = 1;
        this.$set(this.items, index, product);
      }
    },
    removeItem: function (index) {
      this.$emit("remove", index);
    },
    async send() {
      let rec = {}
      rec['action'] = 'create_order'
      rec['licensee'] = this.licensee
      rec['customer'] = this.customer
      rec['transporter'] = this.transporter
      rec['cart'] = this.items
      rec['notes'] = this.notes
      rec['total'] = this.subTotal
      let res = await axiosInstances.apiServer.post("/dt/v1/temp_distribution", rec)
      this.$router.push('DisSales')
      // console.log(rec, res, 'end')
    }
  },
  async mounted() {
    let res = await axiosInstances.apiServer.get("/dt/v1/set_clients")
    this.customers = res.data == null ? [] : res.data.filter(i => i.own != 'yes')
    this.licenses = res.data == null ? [] : res.data.filter(i => i.own == 'yes')
    this.transporters = res.data == null ? [] : res.data
    // console.log("customers", this.customers);
  }
};
</script>

<style scoped>
/* table, th {
  border: 1px solid;
  border-collapse: collapse;
} */
/* tr, th, td {
  padding: 5px;
  border-bottom: 1px solid;
} */
tr, th, td {
  padding: 10px;
  border-bottom: 1px solid;
  text-align: center;
}

* {
  box-sizing: border-box;
}

html {
  font-size: 12px;
}

body {
  margin: 2 0;
  padding: 0;
  font-family: arial, sans-serif;
  overflow: scroll;
}

img {
  max-width: 100%;
  vertical-align: middle;
  border-radius: 4px;
}

a {
  text-decoration: none;
  /* color: #333333; */
}

a:hover {
  color: #f58551;
}

.nav {
  background-color: #16cc9b;
  /* border: 2px solid #16cc9b; */
  cursor: pointer;
}

div.btn__content {
  padding: 5px;
}

.sbutton {
  background-color: #16cc9b;
  border: 2px solid #16cc9b;
  padding: 5px;
  /* color: #ffffff; */
  transition: all 0.25s linear;
  cursor: pointer;
}

.sbutton::after {
  position: relative;
  right: 0;
  content: " \276f";
  transition: all 0.15s linear;
}

.sbutton:hover {
  /* background-color: #f58551; */
  border-color: #f58551;
}

.sbutton:hover::after {
  right: -5px;
}

.sbutton:focus {
  outline: none;
}

ul {
  padding: 0;
  margin: 0;
  list-style-type: none;
}

input {
  transition: all 0.25s linear;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  margin: 0;
}

input {
  outline: none;
}

.container {
  width: 100%;
  margin: 0 auto;
  overflow: auto;
  padding: 12px;
  padding-left: 0px;
}

/* --- HEADER --- */
header.container {
  margin-bottom: 0rem;
}

header .breadcrumb {
  color: #7d7d7d;
}

header .breadcrumb li {
  float: left;
  padding: 0 6px;
  height: 20px;
  line-height: 20px;
}

header .breadcrumb li:first-child {
  padding-left: 2px;
}

header .breadcrumb li:not(:last-child)::after {
  content: " \276f";
  padding-left: 8px;
}

header .count {
  float: right;
  /* color: #333333; */
  height: 12px;
  line-height: 12px;
}

/* --- PRODUCT LIST --- */
.products {
  /* border-top: 1px solid #ddd; */
}

.products > li {
  padding: 1rem 0;
  border-bottom: 1px solid #ddd;
}

.row {
  position: relative;
  overflow: auto;
  width: 100%;
}

.col,
.remove {
  float: left;
}

.quantity {
  float:unset;
}

.col.left {
  width: 50%;
}

.col.right {
  width: 50%;
  position: absolute;
  right: 0;
  top: calc(50% - 30px);
}

.detail {
  padding: 0 0.5rem;
  line-height: 1.2rem;
}

.detail .name {
  font-size: 1rem;
  font-weight: bold;
}

.detail .description {
  /* color: #7d7d7d; */
  font-size: 1rem;
}

.detail .price {
  font-size: 1.2rem;
}

.quantity,
.remove {
  width: 50%;
  text-align: center;
}

.remove svg {
  width: 40px;
  height: 40px;
}

.quantity > input {
  display: inline-block;
  width: 60px;
  height: 30px;
  position: relative;
  /* left: calc(50% - 30px); */
  /* background: #fff; */
  border: 2px solid #ddd;
  color: #7f7f7f;
  text-align: center;
  font: 600 1.2rem Helvetica, Arial, sans-serif;
}

.quantity > input:hover,
.quantity > input:focus {
  border-color: #f58551;
}

.close {
  fill: #7d7d7d;
  transition: color 150ms linear, background-color 150ms linear,
    fill 150ms linear, 150ms opacity linear;
  cursor: pointer;
}

.close:hover {
  fill: #f58551;
}

/* --- SUMMARY --- */
.promotion,
.summary,
.checkout {
  float: left;
  width: 100%;
  margin-top: 0.2rem;
}

.promotion > label {
  float: left;
  width: 100%;
  margin-bottom: 1rem;
}

.promotion > input {
  float: left;
  width: 80%;
  font-size: 1rem;
  padding: 0.5rem 0 0.5rem 1.8rem;
  border: 2px solid #16cc9b;
  border-radius: 2rem 0 0 2rem;
}

.promotion:hover > input {
  border-color: #f58551;
}

.promotion > button {
  float: left;
  width: 20%;
  height: 2.4rem;
  border-radius: 0 2rem 2rem 0;
}

.promotion:hover > button {
  border-color: #f58551;
  background-color: #f58551;
}

.promotion > button::after {
  content: "\276f";
  font-size: 1rem;
}

.summary {
  font-size: 1.2rem;
  text-align: right;
}

.summary ul li {
  padding: 0.5rem 0;
}

.summary ul li span {
  display: inline-block;
  width: 30%;
}

.summary ul li.total {
  font-weight: bold;
}

.checkout {
  text-align: right;
}

.checkout > button {
  font-size: 1.2rem;
  padding: 0.8rem 2.8rem;
  border-radius: 1.5rem;
}

.empty-product {
  text-align: center;
}

.empty-product > button {
  font-size: 1.3rem;
  padding: 10px 30px;
  border-radius: 5px;
}

/* --- SMALL SCREEN --- */
@media all and (max-width: 599px) {
  .thumbnail img {
    display: none;
  }

  .quantity > input {
    width: 80px;
    height: 30px;
    left: calc(50% - 20px);
  }

  .remove svg {
    width: 30px;
    height: 30px;
  }
}

/* --- MEDIUM & LARGE SCREEN --- */
@media all and (min-width: 600px) {
  html {
    font-size: 14px;
  }

  .container {
    width: 100%;
    padding: 12px;
    padding-left: 0px;
    /* max-width: 960px; */
  }

  .thumbnail,
  .detail {
    float: left;
  }

  .thumbnail {
    width: 25%;
  }

  .detail {
    width: 65%;
  }

  .promotion,
  .summary {
    width: 50%;
  }

  .checkout {
    width: 100%;
  }

  .checkout,
  .summary {
    text-align: right;
  }
}

/* --- LARGE SCREEN --- */
@media all and (min-width: 992px) {
  html {
    font-size: 16px;
  }
}
</style>